import { defineMessages } from 'react-intl';

export default defineMessages({
  bottomBannerTitle: {
    id: `landing.teacher.faq.bottom.banner.title`,
    defaultMessage: `Tu as trouvé les réponses à tes questions ? `,
  },
  bottomBannerButton: {
    id: `landing.teacher.faq.bottom.banner.button`,
    defaultMessage: `Oui, je veux devenir Sherpa !`,
  },
  bottomBannerCaption: {
    id: `landing.teacher.faq.bottom.banner.caption`,
    defaultMessage: `Tu n’as pas trouvé de réponse à tes questions ?
Plus d’informations sur : <link>La FAQ des Sherpas.</link>`,
  },
  item1Title: {
    id: `landing.teacher.faq.item1.title`,
    defaultMessage: `Quelles conditions pour devenir Sherpa ?`,
  },
  item1Description: {
    id: `landing.teacher.faq.item1.description`,
    defaultMessage: `<strong>Pour devenir professeur sur Les Sherpas, tu dois avoir au moins 16 ans, être étudiant, professeur de l’éducation nationale ou professionnel et pouvoir justifier de ton expérience dans les matières que tu souhaites enseigner !</strong>
    
  Pour candidater, tu devras nous fournir un justificatif pertinent pour chaque matière : relevé de notes, diplôme, certificat de scolarité et tout ce qui pourra nous aider pour te certifier.`,
  },
  item2Title: {
    id: `landing.teacher.faq.item2.title`,
    defaultMessage: `Comment fonctionnent les cours ?`,
  },
  item2Description: {
    id: `landing.teacher.faq.item2.description`,
    defaultMessage: `<strong>Sur Les Sherpas, tu es 100% libre !</strong> Tu fixes tes tarifs, lieux et horaires : c’est à toi et ton élève de choisir ce qui vous convient le mieux.
Les cours peuvent donc avoir lieu à domicile (chez l’élève, chez toi ou ailleurs), ou en visioconférence au choix.
Pour fluidifier les paiements, les élèves paient tes cours à l’avance via notre plateforme, ce qui te garantit d’être payé(e). En fin de cours, ils te laissent un avis, ce qui te permet de construire ta réputation et d’obtenir de nouveaux élèves.`,
  },
  item3Title: {
    id: `landing.teacher.faq.item3.title`,
    defaultMessage: `Quelles matières puis-je enseigner ?`,
  },
  item3Description: {
    id: `landing.teacher.faq.item3.description`,
    defaultMessage: `<strong>Nous proposons toutes les matières académiques disponibles au Primaire, Collège, Lycée, Prépa et dans le Supérieur !</strong>
    
  Dans ta candidature, tu vas choisir les matières et les niveaux auxquels tu souhaites enseigner.
  Au regard de tes pièces justificatives, notre équipe te certifiera pour toutes les matières et niveaux auxquels tu peux prétendre.
  Une fois devenu(e) Sherpa, tu pourras changer à tout moment les matières, les niveaux et les tarifs auxquels tu enseignes dans tes paramètres.`,
  },
  item4Title: {
    id: `landing.teacher.faq.item4.title`,
    defaultMessage: `Dois-je trouver mes propres élèves ?`,
  },
  item4Description: {
    id: `landing.teacher.faq.item4.description`,
    defaultMessage: `<strong>Non, nous allons te proposer régulièrement des élèves.</strong> Dès que tes annonces sont de qualité, tu peux attendre pendant que nous nous occupons de tout ! Dès qu’un élève est intéressé, nous te mettons au courant, et tu n’auras plus qu’à accepter de le rencontrer pour donner ton cours d’essai. `,
  },
  item5Title: {
    id: `landing.teacher.faq.item5.title`,
    defaultMessage: `Dois-je fournir mon propre contenu pour les cours ?`,
  },
  item5Description: {
    id: `landing.teacher.faq.item5.description`,
    defaultMessage: `<strong>Si nous te conseillons de fournir ton propre contenu, car c’est un super plus à proposer à tes élèves, ce n’est pas indispensable pour enseigner sur Les Sherpas.</strong> De nombreuses ressources gratuites sont disponibles en ligne, et notamment sur notre média. De plus, tes étudiants viendront souvent avec leurs propres exercices.`,
  },
});
